import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-password-success',
  templateUrl: './password-success.component.html',
  styleUrls: ['./password-success.component.scss']
})
export class PasswordSuccessComponent {

  showXIcon: boolean = true
  translations: any = {}
  titleStyle: string = ""
  @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>()

  closeModal() {
    this.closeModalEvent.emit();
  }
}
